/**
 * Created by Lucas Wang on 8/17/21.
 * Description:
 * Effects for handling Users page of Admin Page
 * ------ maintenance history ------
 * Modified by Cathy Yao on 09/9/2021:add delete user effects
 */

import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of as observableOf } from 'rxjs';
import { AdminPageActionTypes } from '../../actions/admin-page.actions';
import { UsersService } from '../../../tamalelibs/services/users.service';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { CredentialService } from '../../../tamalelibs/services/credential.service ';

@Injectable()
export class AdminPageUsersEffects {
    constructor(
        private _usersService: UsersService,
        private _actions$: Actions,
        private _credentialService: CredentialService,
    ) { }

    editUserEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(AdminPageActionTypes.EDIT_USER),
        map(action => action as any),
        map(action => action.payload),
        mergeMap((payload) => this._usersService.editUser(payload.user, payload.contactId)
            .pipe(
                map(response => ({
                    type: AdminPageActionTypes.EDIT_USER_SUCCESS,
                    payload: {
                        newUser: response,
                        successMessage: payload.successMessage
                    }
                })),
                catchError(err => {
                    return observableOf({
                        type: AdminPageActionTypes.GENERAL_FAILURE,
                        payload: `${payload.name}-${err.message}`
                    });
                })
            )
        )
    ));

    getUsersEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(AdminPageActionTypes.GET_USERS),
        mergeMap(() => this._usersService.getAdminPageUsersList()
            .pipe(
                map(usersData => ({
                    type: AdminPageActionTypes.GET_USERS_SUCCESS,
                    payload: usersData
                })),
                catchError(err => {
                    return observableOf({
                        type: AdminPageActionTypes.GENERAL_FAILURE,
                        payload: `${err.message}`
                    });
                })
            )
        )
    ));

    getCredential$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(AdminPageActionTypes.GET_SYSTEM_CREDENTIALS),
        mergeMap(() =>
            this._credentialService.getCredentials()
                .pipe(
                    map(response => (
                        {
                            type: AdminPageActionTypes.GET_SYSTEM_CREDENTIALS_SUCCESS,
                            payload: response.credentialList
                        })),
                    catchError(err => {
                        return observableOf({
                            type: AdminPageActionTypes.GET_SYSTEM_CREDENTIALS_FAILURE,
                            payload: []
                        });
                    })
                )
        )
    ));

    newUserEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(AdminPageActionTypes.CREATE_NEW_USER),
        map(action => action as any),
        map(action => action.payload),
        mergeMap((payload) => this._usersService.createNewUser(payload.contactId, payload.user)
            .pipe(
                map(response => ({
                    type: AdminPageActionTypes.CREATE_USER_SUCCESS,
                    payload: {
                        newUser: response,
                        successMessage: payload.successMessage
                    }
                })),
                catchError(err => {
                    return observableOf({
                        type: AdminPageActionTypes.GENERAL_FAILURE,
                        payload: `${payload.name}-${err.message}`
                    });
                })
            )
        )
    ));

    deleteUserEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(AdminPageActionTypes.DELETE_USERS),
        map(action => action as any),
        map(action => action.payload),
        mergeMap((payload) => this._usersService.deleteUser(payload.id)
            .pipe(
                map(response => ({
                    type: AdminPageActionTypes.DELETE_USERS_SUCCESS,
                    payload: {
                        id: payload.id,
                        successMessage: payload.successMessage
                    }
                })),
                catchError(err => {
                    return observableOf({
                        type: AdminPageActionTypes.GENERAL_FAILURE,
                        payload: `${payload.id}-${err.message}`
                    });
                })
            )
        )
    ));

}
